import React from 'react'
import logo from './assets/img/crypto1.png'

const CrfLogo = () => {
  return <img className="h-full w-full object-contain" src={logo} alt="CRF" />
}

export default CrfLogo
